import { Checkbox } from '@silverfort/sf-components';
import React, { ReactNode } from 'react';

interface Props<T extends { selected?: boolean }> {
    policy: { selected?: boolean };
    setPolicy: React.Dispatch<React.SetStateAction<T>>;
    itemTitle: string;
    selectPolicyComponent: ReactNode;
}

const SecurityControlItem = <T extends { selected?: boolean }>({
    policy,
    setPolicy,
    itemTitle,
    selectPolicyComponent
}: Props<T>) => {
    const handleCheckedChange = (setPolicy: React.Dispatch<React.SetStateAction<T>>, newValue: boolean) => {
        setPolicy((prevState) => ({ ...prevState, selected: newValue }));
    };

    return (
        <div className="w-full h-fit flex items-center gap-[8px]">
            <div className="h-full min-w-[160px] flex items-center gap-[8px]">
                <Checkbox
                    onChange={(e) => handleCheckedChange(setPolicy, e.target.checked)}
                    checked={policy.selected}
                />
                <div className="text-13 text-sf-gray-800 font-sf">{itemTitle}</div>
            </div>
            {selectPolicyComponent}
        </div>
    );
};

export default SecurityControlItem;
